import { render, staticRenderFns } from "./HomeTabs.vue?vue&type=template&id=1dc186cf&scoped=true&"
import script from "./HomeTabs.vue?vue&type=script&lang=ts&"
export * from "./HomeTabs.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTabs.vue?vue&type=style&index=0&id=1dc186cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc186cf",
  null
  
)

export default component.exports